import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import { WaveLoading } from 'react-loadingg';

import { PageTitle } from 'components';

import { SettlementToolbar, SettlementTable } from './components';

import { IsNoU } from 'common/utils';

import exportToExcel from 'common/exportToExcel';

// >> redux
import {
  getUserAgencies,
  getUserClients,
} from 'redux/actions/companies';
// <<


// >> redux
import {
  //getSettlements,
  findSettlement,
  removeSettlement,
} from 'redux/actions/settlements';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Settlement = (props) => {
  const classes = useStyles();

  const { type } = props.match.params;

  const { advertises, agencies, clients, loading, loading_find_settlement, settlement_total } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [selectedSettlements, setSelectedSettlements] = useState([]);

  const [find_data, set_find_data] = useState({});

  const handleFindAdvertises = (agency, client) => {
  
    let find = {};

    if (!IsNoU(userId) && userId.length > 0)
      find.userId = userId;

    if (!IsNoU(agency) && agency.length > 0 && agency !== '전체')
      find.agency = agency;

    if (!IsNoU(client) && client.length > 0 && client !== '전체')
      find.client = client;

    find.page = 0;
    find.rows_per_page = rowsPerPage;

    set_find_data(find);

    props.findSettlement(find);
  }

  const [selectedAgency, setSelectedAgency] = useState('');
  const [selectedClient, setSelectedClient] = useState('');

  const [agencyClients, setAgencyClients] = useState([]);
  const handleChangeAgency = e => {
    let newAgencyClients = clients.filter(client => client.agency === e.target.value);
    //console.log('new agency clients ->');
    //console.log(newAgencyClients);
    setAgencyClients(newAgencyClients);
    setSelectedClient('');
    setSelectedAgency(e.target.value);
  };

  const handleChangeClient = event => {
    setSelectedClient(event.target.value);
  };

  const handleExportExcel = () => {

    if (IsNoU(advertises) || advertises.length <= 0) {
      return ;
    }

    const excel_datas = advertises.map((advertise, index) => {
      let execel_data;
      if (userRole === 'client') {
        execel_data = { 
          '광고주명': advertise.client, 
          '광고명': advertise.name, 
          //'계약금액':advertise.cost, 
          //'계약카운트': advertise.view_count, 
          '재생횟수': advertise.play_count, 
        //   '카운트달성일자': 
        //     !IsNoU(advertise.complated_at) ? 
        //       moment(advertise.complated_at).format('YYYY-MM-DD') : 
        //       ''
            '시작일자': 
                !IsNoU(advertise.start_date) ? 
                moment(advertise.start_date).format('YYYY-MM-DD') : 
                ''
        };
      }
      else {
        execel_data = { 
          '광고대행사': advertise.agency, 
          '광고주명': advertise.client, 
          '광고명': advertise.name, 
          //'계약금액':advertise.cost, 
          //'계약카운트': advertise.view_count, 
          '재생횟수': advertise.play_count, 
        //   '카운트달성일자': 
        //     !IsNoU(advertise.complated_at) ? 
        //       moment(advertise.complated_at).format('YYYY-MM-DD') : 
        //       ''
            '시작일자': 
                !IsNoU(advertise.start_date) ? 
                moment(advertise.start_date).format('YYYY-MM-DD') : 
                ''
        };
      }
      return execel_data;
    });

    exportToExcel(excel_datas, `현황_${userName}_${moment(new Date()).format('YYYY_MM_DD_hh_mm_ss')}.xlsx`)
  }

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handlePageChange = (event, page) => {
    setPage(page);
    let find_page_data = find_data;
    find_page_data.page = page;
    set_find_data(find_page_data);

    props.findSettlement(find_page_data);
  };

  const handleRowsPerPageChange = e => {
    let rows_per_page = e.target.value;
    setRowsPerPage(rows_per_page);
    setPage(0);

    let find_page_data = find_data;
    find_page_data.page = 0;
    find_page_data.rows_per_page = rows_per_page;
    set_find_data(find_page_data);

    props.findSettlement(find_page_data);
  };

  useEffect(() => {
    //console.log("componentDidMount");

    let user_role = '';
    let req_userid = null;
    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      const decoded = jwtDecode(jwt);

      //console.log(decoded);

      //console.log(decoded.role);
      if (decoded.role !== null) {
        user_role = decoded.role;
        setUserRole(decoded.role);
      }

      if (decoded.userid !== null) {
        if (user_role !== 'admin') {
          req_userid = decoded.userid;
        }
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
    }

    //console.log(userRole);

    //console.log(req_userid);

    props.getUserAgencies(req_userid);
    props.getUserClients(req_userid);
  
    return () => {
      //console.log("componentDidUnmount");
      props.removeSettlement();
    };
  }, []); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log('componentDidUpdate & selectedTemplates changed');

    props.removeSettlement();
 
    // if (type === 'taxi')
    //   props.getSettlement();
    // else if (type === 'cars')
    //   props.getSettlements();

  }, [type]);

  // useEffect(() => {
  //   //console.log('componentDidUpdate & selectedTemplates changed');
 
  //   setDisableEditButton(selectedSettlement.length != 1);
  //   setDisableDeleteButton(selectedSettlement.length < 1);

  // }, [selectedSettlement]);

  // useEffect(() => {
  //   //console.log('componentDidUpdate & selectedTemplates changed');
 
  //   setDisableEditCarButton(selectedSettlements.length != 1);
  //   setDisableDeleteCarButton(selectedSettlements.length < 1);

  // }, [selectedSettlements]);

  // useEffect(() => {
  //   //console.log('componentDidUpdate & selectedTemplates changed');
 
  //   setDisableEditAgencyButton(selectedAgencies.length != 1);
  //   setDisableDeleteAgencyButton(selectedAgencies.length < 1);

  // }, [selectedAgencies]);

  if (loading) {
    return <WaveLoading />;
  }
  
  return (
    <div className={classes.root}>

      {type !== 'agency' && type !== 'client' && <Redirect to="/not-found"/>}

      <PageTitle
        pageTitle={type === 'agency'? '광고대행사별 현황' : '광고주별 현황'}
        />

      <SettlementToolbar 
        user_role={userRole}
        type={type}
        // agencies={[{id:-1, name: '전체'}, ...agencies]}
        // clients={[{id:-1, name: '전체'}, ...clients]}
        agencies={[{id:-1, name: '전체'}, ...agencies]}
        clients={[{id:-1, name: '전체'}, ...agencyClients]}
        selectedAgency={selectedAgency}
        onChangeAgency={handleChangeAgency}
        selectedClient={selectedClient}
        //onSetSelectedClient={client => setSelectedClient(client)}
        onChangeClient={handleChangeClient}

        onClickFindAdverties={handleFindAdvertises}
        />

      <div className={classes.content}>
        <SettlementTable 
          onClickExportExcel={handleExportExcel}
          user_role={userRole}
          type={type}
          items={advertises}
          onSetSelectedItems={(checks) => {setSelectedSettlements(checks)}}
          userName={userName}

          openProgress={loading_find_settlement}
          page={page}
          rowsPerPage={rowsPerPage}
          item_total={settlement_total}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          />
      </div>

    </div>
  );
};

//export default Settlement;


Settlement.propTypes = {
  loading: PropTypes.bool,
  loading_find_settlement: PropTypes.bool, 
  //settlements: PropTypes.arrayOf(PropTypes.object),

  agencies: PropTypes.arrayOf(PropTypes.object),
  clients: PropTypes.arrayOf(PropTypes.object),

  advertises: PropTypes.arrayOf(PropTypes.object),
  settlement_total: PropTypes.number,
};

Settlement.defaultProps = {
  loading: false,
  loading_find_settlement: false,
  //settlements: [],

  agencies: [],
  clients: [],

  advertises: [],
  settlement_total: 0,
};

const mapStateToProps = state => ({
  loading: state.settlements.loading,// | state.companies.loading,
  loading_find_settlement: state.settlements.find_settlement_loading,
  //settlements: state.settlements.settlementList,
  advertises: state.settlements.advertiseList,
  settlement_total: state.settlements.settlement_total,

  agencies: state.companies.reged_agencyList,
  clients: state.companies.reged_clientList,

});

const mapDispatchToProps = dispatch => ({
  //getSettlements: () => {getSettlements(dispatch)},
  // addStatistic: (statistic) => {addStatistic(statistic, dispatch)},
  // updateStatistic: (id, statistic) => {updateStatistic(id, statistic, dispatch)},
  // deleteSettlement: (deletes) => {deleteCar(deletes, dispatch)},

  findSettlement: (find) => {findSettlement(find, dispatch)},
  removeSettlement: () => {removeSettlement(dispatch)},

  getUserAgencies: (userid) => {getUserAgencies(userid, dispatch)},
  getUserClients: (userid) => {getUserClients(userid, dispatch)},
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Settlement);

